import { fromBech32, toHex } from "@cosmjs/encoding";

export const valconsToBase64 = (address: string) => {
  if (address) return toHex(fromBech32(address).data).toUpperCase();
  return "";
};
